import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  const w = window as any;
  if (w.fbq) return;
  const n: any = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  w.fbq = n;
  w._fbq = n;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  w.fbq('init', '1298571652372962');
  w.fbq('track', 'PageView');
})();
(function (c: any, l: any, a: string, r: string, i: string) {
  c[a] = c[a] || function (...args: any[]) {
    ;
    (c[a].q = c[a].q || []).push(args);
  };
  const t = l.createElement(r) as HTMLScriptElement;
  t.async = true;
  t.src = 'https://www.clarity.ms/tag/' + i;
  const y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, 'clarity', 'script', 'wjdj0pm1l5');
render(<App data-id="element-242" />, document.getElementById('root'));